// Converts snake_case and camelCase to Title Case for display (e.g. tool/action names).
export const formatKey = (key) =>
  String(key ?? '')
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

const IMAGE_CELL_HEIGHT = 120;
const IMAGE_CELL_MIN_WIDTH = 70;
const IMAGE_CELL_MAX_WIDTH = 260;

// Sized from the requested imageGenerationParams (width/height), not the eventual pixel
// dimensions of the rendered file — those params are echoed back per image on 'image-started'
// and are all we have client-side without re-probing the actual image.
export const imageCellSize = (image) => {
  const { width, height } = image.params || {};
  if (!width || !height) {
    return { width: IMAGE_CELL_HEIGHT, height: IMAGE_CELL_HEIGHT };
  }
  const scaledWidth = Math.round(IMAGE_CELL_HEIGHT * (width / height));
  return { width: Math.min(Math.max(scaledWidth, IMAGE_CELL_MIN_WIDTH), IMAGE_CELL_MAX_WIDTH), height: IMAGE_CELL_HEIGHT };
};
